export enum TipoMarcaVeiculo {
  CHEVROLET = 'CHEVROLET',
  FIAT = 'FIAT',
  FORD = 'FORD',
  HONDA = 'HONDA',
  HYUNDAI = 'HYUNDAI',
  IVECO = 'IVECO',
  MAN = 'MAN',
  MERCEDESBENZ = 'MERCEDES-BENZ',
  PEUGEOT = 'PEUGEOT',
  RENAULT = 'RENAULT',
  SCANIA = 'SCANIA',
  TOYOTA = 'TOYOTA',
  VOLKSWAGEN = 'VOLKSWAGEN',
  VOLVO = 'VOLVO',
  YAMAHA = 'YAMAHA',
  OUTROS = 'OUTROS',
}
